import type { JudgeFormFieldsetProps } from './JudgeFormFieldset.types';

export const JudgeFormFieldset = ({ legend, hint, children }: JudgeFormFieldsetProps) => (
	<fieldset className="flex flex-col gap-2xs">
		<legend className="text-[11px] font-medium uppercase tracking-wider text-subtle">{legend}</legend>
		{children}
		{hint && <p className="text-[11px] text-subtle">{hint}</p>}
	</fieldset>
);
